/**
 * created by hyw
 * on 2019/11/20
 * desc: 求模算法
 * https://github.com/openmrs/openmrs-module-idgen/blob/master/api/src/main/java/org/openmrs/module/idgen/validator/LuhnMod10IdentifierValidator.java
 */
export default class LuhnModNValidator {

    static getBaseCharacters(){
        return '0123456789ABCDEF'
    }


    static standardizeValidIdentifier(validIdentifier) {
        if (validIdentifier != null) {
            validIdentifier = validIdentifier.toUpperCase().trim();
        }
        return validIdentifier;
    }



    static computeCheckDigit(undecoratedIdentifier){
        let factor = 2;
        let sum = 0;
        let inputChars = LuhnModNValidator.standardizeValidIdentifier(undecoratedIdentifier).split('')
        let baseChars = LuhnModNValidator.getBaseCharacters().split('');
        let mod = baseChars.length;

        // Starting from the right and working leftwards is easier since the initial "factor" will always be "2"
        for (let i = inputChars.length - 1; i >= 0; i--) {
            let codePoint = -1;
            for (let j = 0; j < baseChars.length; j++) {
                if (baseChars[j] == inputChars[i]) {
                    codePoint = j;
                }
            }
            if (codePoint == -1) {
                throw new Error("Invalid character specified for validator");
            }
            let addend = factor * codePoint;

            // Alternate the "factor" that each "codePoint" is multiplied by
            factor = (factor == 2) ? 1 : 2;

            // Sum the digits as expressed in base "n"
            addend = Math.floor((addend / mod) + (addend % mod));
            sum += addend;
        }

        // Calculate the number that must be added to the "sum" to make it divisible by "n"
        let remainder = sum % mod;
        let checkCodePoint = mod - remainder;
        checkCodePoint %= mod;

        return baseChars[checkCodePoint];
    }


}

